import React from 'react'
import { Button, DatePicker, Flex, notification, Typography } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import {
  useClearTimeOffClockMutation,
  useGetTimeOffClockOffsetQuery,
  useSetTimeOffClockMutation,
} from '@/features/time-off/time-off.api.ts'
import { handleApiError } from '@/utils/api.tsx'
import { ClockCircleOutlined } from '@ant-design/icons'

export const TimeTravelPanel: React.FC = () => {
  const [setTimeOffClock, { isLoading: isSettingClock }] = useSetTimeOffClockMutation()
  const [clearTimeOffClock, { isLoading: isClearingClock }] = useClearTimeOffClockMutation()
  const { data: clockOffset, refetch: refetchOffset } = useGetTimeOffClockOffsetQuery()

  const [travelTime, setTravelTime] = React.useState<Dayjs | null>(null)

  const currentVirtualTime = clockOffset
    ? dayjs().add(clockOffset, 'second')
    : null

  const handleSetClock = async () => {
    if (!travelTime) return
    try {
      await setTimeOffClock({ simulatedUtcTime: travelTime.toISOString() }).unwrap()
      notification.success({ message: 'Clock set successfully' })
    } catch (e) {
      handleApiError(e)
    }
  }

  const handleClearClock = async () => {
    try {
      await clearTimeOffClock().unwrap()
      notification.success({ message: 'Clock reset to real time' })
      setTravelTime(null)
      refetchOffset()
    } catch (e) {
      handleApiError(e)
    }
  }

  return (
    <Flex vertical gap="small">
      <Typography.Text type="danger">
        <ClockCircleOutlined /> Virtual Time: <Typography.Text strong>{currentVirtualTime ? currentVirtualTime.format('YYYY-MM-DD HH:mm:ss') : 'Not Set'}</Typography.Text>
        {clockOffset !== 0 && <Typography.Text type="warning"> (offset: {clockOffset}s)</Typography.Text>}
      </Typography.Text>
      <Flex gap="small" align="center">
        <DatePicker
          showTime
          value={travelTime}
          onChange={setTravelTime}
          placeholder="Select target time"
          style={{ width: 240 }}
        />
        <Button type="primary" onClick={handleSetClock} loading={isSettingClock} disabled={!travelTime}>
          Set Clock
        </Button>
        <Button onClick={handleClearClock} loading={isClearingClock}>
          Reset to Real Time
        </Button>
        <Button onClick={() => refetchOffset()}>Refresh</Button>
      </Flex>
    </Flex>
  )
}
